import React from 'react';
import PropTypes from 'prop-types';
import Styles from './TeamTypeSelector.module.css';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';

const View = ({ itemName, allItems, selected, handleChange, refining, handleClearAll, handleSelectAll, onRefineChange, isStartWith }) => (
	<div className={Styles.container}>
		{!isStartWith && (
			<FormControlLabel control={<Checkbox checked={refining} />} label="Refine" labelPlacement="top" onChange={onRefineChange} className={Styles.refining} />
		)}
		<FormControl component="fieldset" disabled={!refining}>
			<FormLabel component="legend">{itemName}</FormLabel>
			<FormGroup>
				{allItems.map(item => (
					<FormControlLabel control={<Checkbox checked={selected.has(item)} onChange={handleChange} name={item} />} label={item} key={item} />
				))}
			</FormGroup>
		</FormControl>
		<div className={Styles.buttons}>
			<Button size="small" className={Styles.button} disabled={!refining} onClick={handleClearAll}>
				Clear All
			</Button>
			<Button size="small" className={Styles.button} disabled={!refining} onClick={handleSelectAll}>
				Select All
			</Button>
		</div>
	</div>
);

View.propTypes = {
	isStartWith: PropTypes.bool.isRequired,
	itemName: PropTypes.string.isRequired,
	allItems: PropTypes.arrayOf(PropTypes.string).isRequired,
	selected: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired,
	refining: PropTypes.bool.isRequired,
	handleClearAll: PropTypes.func.isRequired,
	handleSelectAll: PropTypes.func.isRequired,
	onRefineChange: PropTypes.func.isRequired
};

export default View;
